import usePreference from './usePreference';
import { ProductListParamsKeywordType as KeywordType } from 'services/api/conversation';

const defaultSidebarProductSearchKeywordType: Record<General.PlatformTunnel, KeywordType> = {
  shopee: KeywordType.ITEM_NAME,
  lazada: KeywordType.ITEM_NAME,
  tokopedia: KeywordType.ITEM_NAME,
  tiktok: KeywordType.ITEM_NAME,
  aliexpress: KeywordType.ITEM_NAME,
  mercado: KeywordType.ITEM_NAME,
  tiktok_us: KeywordType.ITEM_NAME,
  kwai: KeywordType.ITEM_NAME,
  facebook: KeywordType.ITEM_NAME,
  wa_biz: KeywordType.ITEM_NAME,
  jolect: KeywordType.ITEM_NAME,
};

export const useKeyTypePreference = (platform: General.PlatformTunnel) => {
  const { getPreference, setPreference } = usePreference();

  const getSidebarProductSearchKeywordType = async () => {
    const value = await getPreference(`${platform}_SidebarProductSearchKeywordType`);
    return value ? JSON.parse(value) : defaultSidebarProductSearchKeywordType[platform];
  };

  const setSidebarProductSearchKeywordType = (keywordType: KeywordType) => {
    return setPreference(
      `${platform}_SidebarProductSearchKeywordType`,
      JSON.stringify(keywordType),
    );
  };

  return {
    getSidebarProductSearchKeywordType,
    setSidebarProductSearchKeywordType,
  };
};
